import { useReportClock } from '../../reportClock';
import React, { Fragment, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { PlusSquare } from 'react-feather';
import { Row, Col, Card, CardBody } from 'reactstrap';
import { H2, P } from '../../../../AbstractElements';
import Usertable from "./Usertable";
import { loadUsersProgressively } from "../userFirebase";
import i18n from '../../../../i18n';


const Userlist = () => {
  const reportNow = useReportClock();

  const [allUsers, setAllUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(true);
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    let isActive = true;

    const applyUsers = ({ users, errors, complete = true }) => {
      if (!isActive || !complete) {
        return;
      }

      setAllUsers(users);
      setLoadingUsers(false);

      if (errors.length) {
        setErrorMsg(i18n.t('Dashboard_Users_PartialLoadError'));
      }
    };

    const fetchUsers = async () => {
      setErrorMsg('');

      try {
        const result = await loadUsersProgressively({ forceRefresh: true, requireServer: true, onUpdate: applyUsers });
        applyUsers(result);
      } catch (error) {
        console.error(error);
        if (isActive) {
          setErrorMsg(i18n.t('Dashboard_Users_LoadError'));
          setAllUsers([]);
        }
      } finally {
        if (isActive) {
          setLoadingUsers(false);
        }
      }
    };
  
    fetchUsers();

    return () => {
      isActive = false;
    };
  }, [reportNow]);



  return (
    <Fragment>
      <Row>
        <Col sm="12" md="12">
          <Card>
            <CardBody>
              <Row className="">
                <Col md="8">
                  <H2 attrH6={{ className: 'title' }}>{i18n.t('Dashboard_Users_Title')}</H2>
                  <P>{i18n.t('Dashboard_Users_Description')}</P>
                </Col>
                <Col md="4">
                  <Link to={`${process.env.PUBLIC_URL}/dashboard/users/add`}>
                    <button type='button' className='btn btn-primary btn-block btn-maxpark pull-right'><span className="icon-button-fix"><PlusSquare className="h-20"/></span>{i18n.t('Dashboard_Users_Create')}</button>
                  </Link>
                </Col>
              </Row>

              <Row className="m-t-20">
                <Col md="12">
                  {errorMsg ? <P attrPara={{ className: "text-danger" }}>{errorMsg}</P> : ""}
                  {loadingUsers
                    ? <P>{i18n.t('Dashboard_Users_Loading')}</P>
                    : <Usertable userlist={allUsers}/>
                  }
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Fragment >

  )

}
export default Userlist;
